import { onApiError } from "../error"
import { put } from "./client"

/**
 * @param {string} email 
 */
async function sendVerificationCode(email) {
    const res = await put("/send-verification-code", {
        body: JSON.stringify({
            Email: email
        })
    })

    if (!res.ok) throw await onApiError(res)
}

export {
    sendVerificationCode
}
